






























































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'
import { maskMoney } from '@/utils/common'
import { isDataVazia } from '@/utils/dataHora'

@Component
export default class FinanceiroTabelaRegraGestao extends Vue {
  deleteRegraDeCalculo: boolean = false
  loadingEditarRegraDeCalculo: string = ''
  loadingDeleteCalculo: boolean = false
  searchGestor: string = ''
  loadingGestorFilter: boolean = false
  
  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get regrasDeGestao() { return this.getRegrasDeCalculoStore.regraGestao }

  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }

  get fontePagadora() { return this.getRegrasDeCalculoStore.regraGestaoItem.fontePagadoraId }
  set fontePagadora(value: string) { this.getRegrasDeCalculoStore.setRegraGestaoItem({ ...this.getRegrasDeCalculoStore.regraGestaoItem, fontePagadoraId: value }) }
  
  get gestores() { return this.getRegrasDeCalculoStore.gestores }

  get locaisExecucao() { return this.getRegrasDeCalculoStore.locaisExecucao }

  get gestor() { return this.getRegrasDeCalculoStore.regraGestaoItem.gestorId }
  set gestor(value: string) { this.getRegrasDeCalculoStore.setRegraGestaoItem({ ...this.getRegrasDeCalculoStore.regraGestaoItem, gestorId: value }) }

  get localExecucao() { return this.getRegrasDeCalculoStore.regraGestaoItem.localExecucaoId }
  set localExecucao(value: string) { this.getRegrasDeCalculoStore.setRegraGestaoItem({ ...this.getRegrasDeCalculoStore.regraGestaoItem, localExecucaoId: value }) }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get showModalAddRegra() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGestao }
  set showModalAddRegra(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGestao', value }) }

  get showModalDelete() { return this.deleteRegraDeCalculo }
  set showModalDelete(value: boolean) { this.deleteRegraDeCalculo = value }

  get paginacao() { return this.getRegrasDeCalculoStore.paginacaoRegraGestao }

  gestoresDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getGestores(param), 500)

  headers = [
    { text: 'Fonte pagadora', value: 'nomeFontePagadora', sortable: false },
    { text: 'Nome gestor', value: 'nomeGestor', sortable: false },
    { text: 'Local execução', value: 'nomeLocalExecucao', sortable: false },
    { text: 'Grupo repasse', value: 'nomeGrupoRepasse', sortable: false },
    { text: 'Tipo', value: 'tipoCarga', sortable: false },
    { text: 'Valor', value: 'valor', sortable: false },
    { text: 'Criado por', value: 'nomeCreatedBy', sortable: false },
    { text: 'Criado em', value: 'createdOn', sortable: false },
    { text: 'Inicio vigência', value: 'vigenciaInicio', sortable: false },
    { text: 'Fim vigência', value: 'vigenciaFim', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  displayDate(value: any) {
    if (isDataVazia(value)) return ' - '
    return moment(value).format('DD/MM/YYYY')
  }

  formatMoneyUtil(value: any) {
    return maskMoney(value)
  }

  openModalDelete(id: string) {
    this.getRegrasDeCalculoStore.setIdRegraGestor(id)
    this.showModalDelete = true
  }

  filterResults(){
    this.loadingRegrasDeCalculo = true
    this.getRegrasDeCalculoStore.getRegrasGestao(this.paginacao)
    this.loadingRegrasDeCalculo = false
  }

  async editar(item: any) {
    this.loadingEditarRegraDeCalculo = item.id
    this.getRegrasDeCalculoStore.setModeModalRegraGestao('EDIT')
    this.getRegrasDeCalculoStore.setRegraGestaoItem({
      ...item,
      fontePagadoraFiltroId: item.fontePagadoraId,
      filtrarPorLocal: !!item.localExecucaoId,
    })
    this.getRegrasDeCalculoStore.setIdRegraGestor(item.id)
    this.showModalAddRegra = true
    this.loadingEditarRegraDeCalculo = ''
  }

  async deleteItem() {
    this.loadingDeleteCalculo = true
    const request = await this.getRegrasDeCalculoStore.deleteRegraGestao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeleteCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Regra de cálculo excluída com sucesso!',
      icon: 'check',
      color: '#43A047',
    })
    this.showModalDelete = false
    this.loadingDeleteCalculo = false
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegrasGestao(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    this.loadingRegrasDeCalculo = true
    this.regrasDeCalculoDebounced(pagination)
    this.loadingRegrasDeCalculo = false
  }

  @Watch('searchGestor')
  async onSearchGestorChanged(val: string) {
    if (!val || val.length < 3) {
      this.getRegrasDeCalculoStore.setGestores([])
      return
    }

    this.loadingGestorFilter = true
    await this.gestoresDebounced(val)
    this.loadingGestorFilter = false
  }

  clearGestorFilter() {
    this.gestor = ''
    this.searchGestor = ''
  }
}
